import Vue from 'vue'
import master from '../masterModules/masterMutation.js'
// location-action
const URL = process.env.API_URL
const header = master.state.header

export default {
  inputUpdate(store, payload) {
    store.commit('inputUpdate', payload)
  },
  updateSelectedReserveList(store, payload) {
    store.commit('updateSelectedReserveList', payload)
  },
  clearSelectedReserveList(store) {
    store.commit('clearSelectedReserveList')
  },
  async addReserve(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: [payload]
    }
    await Vue.http.post(URL + '/v2/admin/reserve/regist', data, config)
  },
  async setReserves(store, payload) {
    store.state.reserves = []
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          pageNo: payload.pageNo,
          count: 20
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/reserve/list',
      data,
      config
    )
    // 成功
    store.commit('setReserves', response)
  },
  async updateReserve(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: [payload]
    }
    await Vue.http.post(URL + '/v2/admin/reserve/update', data, config)
  },
  async deleteReserve(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: [
        {
          reserveId: payload.reserveId
        }
      ]
    }
    await Vue.http.post(URL + '/v2/admin/reserve/delete', data, config)
  },
  async setDetailReserve(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          reserveId: payload.reserveId
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/reserve/detail',
      data,
      config
    )
    // 成功
    store.commit('setDetail', response)
  },
  async verifyReserve(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          reserveId: payload.reserveId
        }
      ]
    }
    await Vue.http.post(URL + '/v2/admin/reserve/verify', data, config)
  },
  async setDownloadFile(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      responseType: 'arraybuffer',
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          reserveId: payload.reserveId
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/reserve/download',
      data,
      config
    )
    store.commit('downloadFile', response)
  },
  async downloadTemplate(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      responseType: 'arraybuffer',
      timeout: 1000 * 30
    }
    var response = await Vue.http.get(
      URL + '/v2/admin/reserve/template',
      config
    )
    store.commit('downloadTemplate', response)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/reserveModules/actions.js